import { render, staticRenderFns } from "./FiveStarsRating.vue?vue&type=template&id=37e71c2a&scoped=true&"
import script from "./FiveStarsRating.vue?vue&type=script&lang=js&"
export * from "./FiveStarsRating.vue?vue&type=script&lang=js&"
import style0 from "./FiveStarsRating.vue?vue&type=style&index=0&id=37e71c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e71c2a",
  null
  
)

export default component.exports